import { api_configuration } from "../../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import api_settings = api_configuration.libraries.gui_definition_lib.types.settings.alan_api;
import openViewOnNode from "../../front/openViewOnNode";
import { addMessage } from "../../front/messages";
import * as mapToIdPathBuilder from "../../state/mapToIdPathBuilder";
import DestructorTree from "../../DestructorTree";
import { registerQueryEntry } from "../../state/registerClientState";
import { iReference } from "../../state/Reference";
import * as Rule from "../../state/Rule";
import { Result, isResolved } from "../../Status";
import createIdPathBuilderFromClientIdPath from "../../navigation/createIdPathBuilderFromClientIdPath";
import { scalarValue } from "../../../../../../stream";

export function reference(
	reference: api_cs.Cyes__navigable,
	view: api_views.Cviews__,
	window: api_settings.Cwindows
): void {
	optional_node(iReference(reference).referencedNode.value, view, window);
}

export function state_rule(rule: api_cs.Crules, view: api_views.Cviews__, window: api_settings.Cwindows): void {
	optional_node(scalarValue(Rule.node(rule)), view, window);
}

function optional_node(
	optional_node: Result<api_cs.Cnode>,
	view: api_views.Cviews__,
	window: api_settings.Cwindows
): void {
	if (!(optional_node instanceof api_cs.Cnode)) {
		addMessage("warning", "Cannot open item", { body: "The item cannot be found." });
		return;
	}
	openViewOnNode(optional_node.input.entity().output.node(), view, window);
}

export function node(node: api_cs.Cnode, view: api_views.Cviews__, window: api_settings.Cwindows): void {
	openViewOnNode(node, view, window);
}

export function entity(node_of_entity: api_cs.Cnode, view: api_views.Cviews__, window: api_settings.Cwindows): void {
	openViewOnNode(node_of_entity.input.entity().input.node(), view, window);
}

export function entry(
	entry: api_cs.Centries__yes__has_result,
	view: api_views.Cviews__,
	window: api_settings.Cwindows
): void {
	entry.parent.parent.properties.use_for.switch({
		query: async () => {
			entry.properties.entry_status.properties.initialized.switch({
				no: ($) => {
					const destructor = new DestructorTree();
					registerQueryEntry(entry.properties.entry_status, destructor);
					const open_view = openViewOnNode(
						mapToIdPathBuilder.fromClientState($.properties.referenced_node),
						view,
						window
					);
					open_view.onDestroy(() => destructor.destroy());
				},
				yes: ($) => {
					openViewOnNode($.properties.referenced_node.output.result_node(), view, window);
				},
				unknown: undefined,
			});
		},
		candidates: async ($) => {
			const key = entry.key;
			const destructor = new DestructorTree();
			entry.onDestroy(() => destructor.destroy());
			const collection = iReference($.inferences.reference_property().parent).collectionContext.value;
			if (!isResolved(collection)) {
				addMessage("warning", "Cannot open item", { body: "The item cannot be found." });
				return;
			}
			const node = collection.parent.parent.parent;
			node.properties.location.switch({
				local: () =>
					collection.properties.entries.switchOnEntryExists(
						key,
						(entry) => openViewOnNode(entry.properties.node, view, window),
						() => {
							addMessage("warning", "Unable to find entry");
						}
					),
				remote: () => {
					switch (entry.properties.entry_status.properties.initialized.state.name) {
						case "unknown":
							break;
						case "no": {
							const not_initialize = entry.properties.entry_status.properties.initialized.state.node;
							const id_path_builder = createIdPathBuilderFromClientIdPath(not_initialize.properties.referenced_node);
							openViewOnNode(id_path_builder, view, window);
							break;
						}
						case "yes": {
							const initialized = entry.properties.entry_status.properties.initialized.state.node;
							openViewOnNode(initialized.properties.referenced_node.output.result_node(), view, window);
							break;
						}
					}
				},
			});
		},
	});
}
